import { render, staticRenderFns } from "./MemberAdditionalDocs.vue?vue&type=template&id=c6d8bff2"
import script from "./MemberAdditionalDocs.vue?vue&type=script&lang=js"
export * from "./MemberAdditionalDocs.vue?vue&type=script&lang=js"
import style0 from "./MemberAdditionalDocs.vue?vue&type=style&index=0&id=c6d8bff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports